import qs from 'qs'
export function formatDate (date, fmt) {
  'use strict'
  fmt = fmt || 'yyyy-MM-dd'

  if (date && date.toString().length === 10) {
    date = (+date) * 1000
  }

  if (!date) {
    return ''
  }

  if (Object.prototype.toString.call(date) !== '[object Date]') {
    date = new Date(+date)
  }

  let o = {
    'M+': date.getMonth() + 1, //月份
    'd+': date.getDate(), //日
    'h+': date.getHours(), //小时
    'm+': date.getMinutes(), //分
    's+': date.getSeconds(), //秒
    'q+': Math.floor((date.getMonth() + 3) / 3), //季度
    'S': date.getMilliseconds() //毫秒
  }
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  for (let k in o)
    if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))

  return fmt
}

export function getSystemInfo () {
  const ua = navigator.userAgent.toLowerCase()

  if (/android/.test(ua)) {
    return 'android'
  } else if (/iphone|ipad|ipod/.test(ua)) {
    return 'ios'
  }
}

export function isIphonXSeries(isIphone) {
    if (window !== 'undefined' && window && !isIphone) return false;
    const xSeriesConfig = [
        {  //iPhone Xs（Max,Pro Max）
            devicePixelRatio: 3,
            width: 	414,
            height: 896,
        },
        {  // iPhone XR（11）
            devicePixelRatio: 2,
            width: 414,
            height: 896,
        },
        {  // iPhone X（Xs,Pro）
            devicePixelRatio: 3,
            width: 375,
            height: 812,
        },
    ];
    const {
        devicePixelRatio,
        screen: {
            width, height
        }
    } = window;
    return xSeriesConfig.some(item => item.devicePixelRatio === devicePixelRatio && item.width === width && item.height === height);
}

export function throttle (func, wait, options) {
  let timeout, context, args
  let previous = 0
  if (!options) options = {}

  let later = function () {
    previous = options.leading === false ? 0 : new Date().getTime()
    timeout = null
    func.apply(context, args)
    if (!timeout) context = args = null
  }

  let throttled = function () {
    let now = new Date().getTime()
    if (!previous && options.leading === false) previous = now
    let remaining = wait - (now - previous)
    context = this
    args = arguments
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout)
        timeout = null
      }
      previous = now
      func.apply(context, args)
      if (!timeout) context = args = null
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining)
    }
  }
  throttled.cancel = function () {
    clearTimeout(timeout)
    previous = 0
    timeout = null
  }
  return throttled
}

export function request (name, link) {

  let url = decodeURI(link || location.href),
    paraObj = {},
    paraObjList = url.split('?').slice(1),
    paraString = [],
    returnValue = ''

  let requestHandler = function (paraList) {
    let result = []
    for (let index = 0; index < paraList.length; index++) {
      paraList[index] = paraList[index].split('#')[0]
      result.push(paraList[index])
    }
    return result.join('&').split('&')
  }
  paraString = requestHandler(paraObjList)

  // 将所有请求参数放入paraObj
  let temp = ''
  for (let i = 0, length = paraString.length; i < length; i++) {
    temp = paraString[i]
    paraObj[temp.substring(0, temp.indexOf('=')).toLowerCase()] = temp.substring(temp.indexOf('=') + 1, temp.length)
  }

  returnValue = paraObj[name.toLowerCase()] || ''

  return returnValue

}

export function queryObj () {
  const str = location.search
  if (str) {
    let url = str.substr(1), arr = url.split('&'), len = arr.length, i = 0, request = {}
    for (; i < len; i++) {
      request[arr[i].split('=')[0]] = arr[i].split('=')[1]
    }
    return request
  } else {
    return {}
  }
}

export function setcookie (key, value, expireHours) {

  let cookieString = key + '=' + escape(value) + '; path=/'
  //判断是否设置过期时间
  if (expireHours > 0) {
    let date = new Date()
    date.setTime(date.getTime() + expireHours * 3600 * 1000)
    cookieString = cookieString + '; expire=' + date.toGMTString()
  }
  document.cookie = cookieString

}

export function objectMerge (target, source) {
  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  for (const property in source) {
    if (source.hasOwnProperty(property)) {
      const sourceProperty = source[property]
      if (typeof sourceProperty === 'object') {
        target[property] = objectMerge(target[property], sourceProperty)
        continue
      }
      target[property] = sourceProperty
    }
  }
  return target
}

export function setParam (name, val, url) {
  if (typeof name !== 'string') return false
  if (!url) url = window.location.href
  var _name = name.replace(/[\[\]]/g, '\\$&')
  var value = name + '=' + encodeURIComponent(val)
  var regex = new RegExp(_name + '=[^&]*')
  var urlArr = url.split('#')
  var result = ''
  if (regex.exec(url)) { result = url.replace(regex, value) } else { result = urlArr[0] + '&' + value + (urlArr[1] || '') }
  return result
}

export function setParams (obj, url) {
  let result = url || window.location.href
  if (Object.prototype.toString.call(obj) !== '[object Object]') return false
  for (let name in obj) {
    result = setParam(name, obj[name], result)
  }
  return result
}

export function isEmptyObject (obj) {
  for (let key in obj) {
    return false
  }
  return true
}

export function loadJs (url) {
  return new Promise((resovle, reject) => {
    let head = document.querySelector('head')
    let script = document.createElement('script')
    let loaded = false
    script.setAttribute('src', url)
    script.onload = script.onreadystatechange = function () {
      if (!loaded && (!this.readyState || this.readyState == "loaded" || this.readyState == "complete")) {
        loaded = true;
        resovle('success')
        script.onload = script.onreadystatechange = null;
        head.removeChild(script);
      } else {
        reject('not loaded!')
      }
    }

    head.appendChild(script);
  })
}

export function captureException(error){
  return window.$Raven&&window.$Raven.captureException(error)
}

// 存储
// handleLocalStorage('set', 'userName', 'Tom');
// 获取
// handleLocalStorage('get', 'userName');
// 删除
// handleLocalStorage('remove', 'userName');
export function handleLocalStorage(method, key, value) {
    switch (method) {
      case 'get' : {
        let temp = window.localStorage.getItem(key);
        if (temp) {
          return temp
        } else {
          return false
        }
      }
      case 'set' : {
        window.localStorage.setItem(key, value);
        break
      }
      case 'remove': {
        window.localStorage.removeItem(key);
        break
      }
      default : {
        return false
      }
    }
  }

  export function isAndroidBrowser () {
    const u = navigator.userAgent
    return u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
  }

  export function generateEntype(data) {
    let publicKey = "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC2Fp+ZaD/LVASrnQ5eXYyH1peUG3zgCYxer/Gu3qrvpJXhklB31lU2h6u06H1UsNQZ259zAFkac2JJdgi1nqL6FU0l1L8UVyStXhN2coOPBZpRGU4fmA6VMehuWc6bCRkZq4+15388Zz8hO+iWwYj3Q6IaYXwKXpRgCqV7dR6QrQIDAQAB";
    let encrypt = new JSEncrypt()
    encrypt.setPublicKey(publicKey)
    return encrypt.encrypt(data)
}

export function openWeixinClient(){

  const {opplatform} = queryObj();
  if(opplatform && opplatform == 'xs1v1app'){
    const { zm1v1jsBridge } = window;
    if(zm1v1jsBridge){
      zm1v1jsBridge.callHandler('jsToNativeAction', JSON.stringify({ type: 'wakeUpOnlyWeiXin' }))
      return;
    }
  }
  if(navigator.userAgent.includes('app/braintrain')) {
    return;
  }

  location.href = "weixin://";
}

export function isPro(){
  return process.env.NODE_ENV == 'production'
}

export function xiaotiancaoJumpPage(data){
  let url = "http://ai-activity-h5-test.zmaxis.com";
  if(isPro()){
      url = "https://ai-cativity-h5.zmtalent.com";
  }

  const query = {
      commodityType:1,
      channelId:17783,
      mobile:data.mobile ? data.mobile : '',
      level: data.level ? data.level : '',
      platform: 'mobile'
  }
  if(data.subject == '英语启蒙' || data.subject == '北美外教'){
      query.commodityType = 1;
      query.channelId = 17783;
  }else if(data.subject == '语文素养'){
      query.commodityType = 4;
      query.channelId = 17783;
  }
  url = `${url}/wechat-operation/success1?${qs.stringify(query)}`;
  window.location.href = url;
}
